import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ContentArea from '../../components/Template/ContentArea'
import useSize from '../../hooks/useSize'
import { IStore } from '../../reducers'
import Header from './Header'
import Sidebar from './Sidebar'
import {
  getUserCookiesForce,
  getUserCookiesOpen,
  getUserCookiesStep,
  isUserNewPackage,
  isUserNewPremium,
} from '../../reducers/userAccount/selectors/userAccount'
import { UserAccountActions } from '../../reducers/userAccount/actionNames'
import CookiesModal from '../Cookies/CookiesModal'
import { ensureCookiesVersion } from '../Cookies/cookieVersion'
import { useLicensePlansScope } from './Sidebar/Menu'
import { useLocation } from 'react-use'
import { routesToScope } from './index'
import {
  getActiveLicense, isAllInOneLicenseValid,
  isLicenseValid,
  isNewPremiumLicenseValid,
} from '../../reducers/userAccount/selectors/license'
import BetaInfoBanner from '../../components/BetaInfoBanner/BetaInfoBanner'

function Template({ children, isv2 = false }) {
  const size = useSize('calendar')
  const dispatch = useDispatch()
  const isSidebarOpen = useSelector(
    (state: IStore) => state.bookingCalendar.isSidebarOpen,
  )
  const isSidebarBlock = useSelector(
    (state: IStore) => state.bookingCalendar.isSidebarBlock,
  )

  function toggleWithBlock(t: boolean) {
    dispatch({
      isSidebarBlock: t,
      isSidebarOpen: t,
      type: 'toggle left sidebar',
    })
  }

  const cookiesOpen = useSelector(getUserCookiesOpen)
  const closeCookies = () => {
    dispatch({ type: UserAccountActions.CloseCookies })
  }
  const planScope = useLicensePlansScope()
  const activeLicense = useSelector(
    getActiveLicense,
  )
  const isLicenceValid = useSelector(isLicenseValid)
  const newPremium = useSelector(isNewPremiumLicenseValid)
  const isNewPremiumPriceGroup = useSelector(isUserNewPackage)
  const isNewPremiumUser = newPremium && isNewPremiumPriceGroup
  const location = useLocation()
  const isEmployeeAccess = location?.pathname === '/employees' && activeLicense?.has_workers
  const isInvoiceAccess = (location?.pathname === '/invoice-info' || location?.pathname === '/invoice/taxes' || location?.pathname === '/invoice/rates') && activeLicense?.has_invoices
  const scope = routesToScope[location.pathname]
  const isAllInOnePriceGroup = useSelector(isUserNewPremium)
  const isAllInOneUser = useSelector(isAllInOneLicenseValid)
  const isAllInOneFreeUser = !isAllInOneUser && isAllInOnePriceGroup
  const cookiesForce = useSelector(getUserCookiesForce)
  const cookiesStep = useSelector(getUserCookiesStep)
  const shouldAllowCookiesClose = location?.pathname === '/settings' && cookiesForce && cookiesStep === 1
  if (scope && planScope.includes(scope)) {
    if ('routerHistory' in window && (!isLicenceValid || isNewPremiumUser) && !isAllInOneFreeUser) {
      if (isEmployeeAccess) {
        console.log('HAS ACCESS')
      } else if (isInvoiceAccess) {
        console.log('HAS ACCESS')
      } else {
        ;(window as any).routerHistory.push('/upgrade', {})
      }
    }
  }

  setTimeout(() => {
    const hasValidVersion = ensureCookiesVersion()
    const cookies = localStorage.getItem('cookies_v2') || localStorage.getItem('cookies')
    const expire = localStorage.getItem('cookies_expire_v2') || localStorage.getItem('cookies_expire')
    const isExpired = (() => {
      if (!expire) return false
      const d = new Date(expire)
      return isNaN(d.getTime()) ? false : new Date() >= d
    })()
    if (!cookies || isExpired || !hasValidVersion) {
      dispatch({ type: UserAccountActions.OpenCookies, force: isExpired || !hasValidVersion ? true : false, step: isExpired ? 1 : 0 })
    }
  }, 500)

  return (
    <React.Fragment>
      <CookiesModal open={cookiesOpen} onClose={closeCookies} hideClose={!shouldAllowCookiesClose} />
      <Header
        size={size}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleWithBlock}
      />
      <BetaInfoBanner size={size} />
      <Sidebar size={size} />

      <ContentArea
        isv2={isv2}
        size={size}
        isSidebarOpen={isSidebarOpen && isSidebarBlock}
      >
        {children}
      </ContentArea>
    </React.Fragment>
  )
}

export default Template
